<template>
	<div class="header">
		<div class="header_main_box">
			<!-- <img
				class="header_top_title"
				style="margin-top: 10px;"
				src="../../../assets/hot/logo_drcnet.png"
				alt=""
			/> -->
			<div class="titleName">
				{{ ChnName }}
			</div>
		</div>
		<div class="header_main2_box">
			<div class="header_main2_box_list">
				<div
					:class="
						active == '首页'
							? 'header_main2_box_list_content active'
							: 'header_main2_box_list_content'
					"
					@click="linksto('首页')"
				>
					首 页
				</div>
				<div
					:class="
						active == item.name
							? 'header_main2_box_list_content active'
							: 'header_main2_box_list_content'
					"
					v-for="(item, index) in dataListTwo"
					:key="index"
					@click="linksto(item.name, item)"
				>
					{{ item.name }}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import api from '../../../../static/common/api/api.js';
import $ from 'jquery';

export default {
	props: ['dataListTwo', 'ChnName'],
	components: {},
	data() {
		return {
			active: '首页123',
		};
	},
	watch: {},
	methods: {
		//点击导航切换
		linksto(name, item) {
			this.active = name;
			this.$bus.$emit('aMsg', { msg: name, item: item });
		},
	},
	created() {
		window.that = this;
		//给首页传递
		// this.$bus.$emit('aMsg', this.active);
	},
	mounted() {
		//获取从更多点击传的值，修改导航并且传给首页
		this.$bus.$on('bMsg', (all) => {
			this.active = all.msg;
			this.$bus.$emit('aMsg', { msg: all.msg, item: all.items });
		});
	},
	// 不影响其他组件要离开的时候解绑
	beforeDestroy() {
		window.onscroll = null;
	},
};
</script>
<style scoped lang="less">
.header {
	width: 100%;
	height: 319px;
	position: relative;
	background: url('../../../assets/hot/banner.png') no-repeat center;
	background-size: cover;
}
.header_main_box {
	width: 1440px;
	overflow: hidden;
	margin: 0 auto;
}
.header_top_box {
	width: 100%;
	height: 14px;
	line-height: 14px;
	overflow: hidden;
	margin-top: 20px;
}
.header_main2_box {
	width: 99.9%;
	height: 46px;
	position: absolute;
	bottom: 0;
	background: rgba(0, 0, 0, 0.4);
	border: 1px solid rgba(0, 0, 0, 0.4);
}
.header_main2_box_list {
	width: 1440px;
	margin: 0 auto;
	.header_main2_box_list_content {
		display: inline-block;
		height: 46px;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #ffffff;
		line-height: 46px;
		margin-right: 60px;

		cursor: pointer;
	}
	.active {
		border-bottom: 2px solid #fff;
	}
}
.fixed {
	position: fixed;
	top: 0px;
	left: 0px;
	width: 99%;
	height: 74px;
	// opacity: 0.7;
	background: #000;
	z-index: 100;
}

.titleName {
	text-align: center;
	padding: 100px 0 0 0;
	font-size: 50px;
	font-family: Microsoft YaHei;
	font-weight: 400;
	color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/hotcolumn/hotdetail/hotHeader.vue